module.exports = __webpack_public_path__ + "static/hero-f5876ceb35497f24c848286435ea1f30.jpg";